import { render } from "./program-listing-item.vue?vue&type=template&id=1505f6d8"
import script from "./program-listing-item.vue?vue&type=script&lang=js"
export * from "./program-listing-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__